import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import { catchError, EMPTY, tap, throwError } from 'rxjs';
import { ApiConnectivityService } from '../services/api-connectivity.service';
import { API_BASE_URL } from '../../../service/proxy';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const oktaAuth = inject(OKTA_AUTH);
    const router = inject(Router);
    const connectivityService = inject(ApiConnectivityService);
    const apiBaseUrl = inject(API_BASE_URL, { optional: true }) || '';

    const accessToken = oktaAuth.getAccessToken();
    let request = req;

    // Block API requests when there is no valid session token.
    // Allow non-API requests (e.g. static assets) through unmodified.
    const isApiRequest = apiBaseUrl && req.url.startsWith(apiBaseUrl);

    if (isApiRequest && !accessToken) {
        return EMPTY;
    }

    if (accessToken) {
        request = req.clone({
            setHeaders: {
                'Authorization': `Bearer ${accessToken}`
            }
        });
    }

    return next(request).pipe(
        tap(() => {
            connectivityService.reportSuccess();
        }),
        catchError((error: HttpErrorResponse) => {
            if (error.status === 0 || error.status === 504 || error.status === 503 || !navigator.onLine) {
                connectivityService.reportFailure();
            }
            else {
                connectivityService.reportSuccess();
            }

            if (error.status === 403) {
                const body = error.error;
                const isUserNotRegistered =
                    (typeof body === 'object' && body?.error === 'USER_NOT_REGISTERED') ||
                    (typeof body === 'string' && body.includes('USER_NOT_REGISTERED'));

                if (!isUserNotRegistered) {
                    localStorage.removeItem('permissions');
                    localStorage.removeItem('tenants');
                    try { (oktaAuth as any)?.tokenManager?.clear?.(); } catch { /* ignore */ }
                    void router.navigate(['/']);
                }
            }
            return throwError(() => error);
        })
    );
};
